import { render, staticRenderFns } from "./AdminTipiStanzaView.vue?vue&type=template&id=691deaae&"
import script from "./AdminTipiStanzaView.vue?vue&type=script&lang=ts&"
export * from "./AdminTipiStanzaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports